/** OpenAI Realtime tool names — keep in sync with companion / backend function definitions. */
export const MUSIC_LYRICS_REGENERATION = 'music-lyrics-regeneration';
export const MUSIC_ALBUM_COVER_REGENERATION = 'music-album-cover-regeneration';
export const MUSIC_SONG_TITLE_REGENERATION = 'music-song-title-regeneration';
/** Designer image regen — `regenerate-creation` with `type` + `modification_request` in args. */
export const REGENERATE_CREATION = 'regenerate-creation';
